/**
 * Function to validate a phone number
 * 
 * @param phoneNumber 
 */
export const validPhoneNumber = phoneNumber => {
    const re = /^\(?([2-9]{1})([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    const regex = new RegExp(re);
    return regex.test(phoneNumber);
}